<template>
  <div>
    <Header></Header>
    <div class="magezineInCon">
      <div class="top">
        <div class="title open">MAGEZINE</div>
      </div>
      <div class="con">
          <el-carousel
            trigger="click"
            height="77vh"
            arrow="always"
            :interval="2000"
            indicator-position="none"
            :autoplay="false"
            :initial-index="index"
          >
            <el-carousel-item v-for="(item, index) in items" :key="index">
              <img :src="item.cover" alt="" />
              <p>{{item.content}}</p>
            </el-carousel-item>
          </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
      items: [],
      index: 0,
      magazine: ''
    };
  },
  mounted() {
    this.magazine = this.$route.params.magazine
    this.getData()
  },
  methods: {
    async getData() {
      const magazine = await this.$axios.get("magazine", {
      });
      this.items = magazine.data;
      for (let i = 0; i < this.items.length; i++) {
        if(this.magazine == this.items[i].title){
          this.index = i
        }
      }
    },
  },
};
</script>
<style scoped>
.magezineInCon {
  width: 100%;
  height: 100vh;
  padding-top: 8vh;
  background-color: #000;
}
::-webkit-scrollbar {
  display: none;
}
.magezineInCon .top {
  width: 100%;
  min-width: 999px;
  height: 15vh;
  border-top: #888 1px solid;
  border-bottom: #888 1px solid;
  background-color: #000;
  text-align: center;
  position: fixed;
  padding: 0 30px;
  box-sizing: border-box;
  z-index: 2;
}
.magezineInCon .top .title {
  grid-area: 1 / 1 / 2 / 2;
  font-size: 5.5vw;
  line-height: calc(15vh - 2px);
  font-weight: bold;
  color: #fff;
}
@media screen and (max-width:999px){
  .magezineInCon .top .title {
    font-size: 55px;
  }
}
.open {
    width: 29.3vw;
    overflow: hidden;
    display: inline-flex;
    animation: open 1s linear;
}
@media screen and (max-width:999px){
  .open {
    width: 293px;
  }
}
@keyframes open {
    from { width: 0 }
}
.magezineInCon .con {
  width: 100%;
  min-width: 999px;
  height: 77vh;
  top: 23vh;
  position: fixed;
}
.magezineInCon .con .el-carousel__item {
  width: 100%;
  color: #fff;
}
.magezineInCon .con .el-carousel__item img {
  width: 50vh;
  height: 40vh;
  margin: 10vh calc(50% - 25vh) 5vh calc(50% - 25vh);
  object-fit: contain;
}
.magezineInCon .con .el-carousel__item p {
  width: 50%;
  margin: 0 25%;
  font-size: 1.8vh;
  word-break: break-word;
  text-align: center;
}
.magezineInCon .con /deep/ .el-carousel__arrow {
  width: 5vh;
  height: 5vh;
  border: 1px solid #fff;
  font-size: 2.5vh;
  transform: translateY(-10vh);
}
.magezineInCon .con /deep/ .el-carousel__arrow--left {
  left: 22%;
}
.magezineInCon .con /deep/ .el-carousel__arrow--right {
  right: 22%;
}
</style>


// WEBPACK FOOTER //
// src/view/pc/Magazine.vue